import axios from 'axios';
import { API_URL } from '../config';

// Login admin
export const loginAdmin = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/admin/login`, credentials);
    if (response.data.success) {
      localStorage.setItem('adminToken', response.data.token);
      return response.data;
    }
    return { success: false, message: 'Login failed' };
  } catch (error) {
    console.error('Login error:', error);
    return { 
      success: false, 
      message: error.response?.data?.message || 'Login failed' 
    };
  }
};

// Check if admin is logged in
export const isAuthenticated = () => {
  return localStorage.getItem('adminToken') ? true : false;
};

// Logout admin
export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
};

// Get authenticated admin
export const getAdmin = async () => {
  try {
    const token = localStorage.getItem('adminToken');
    if (!token) return { success: false };
    
    const response = await axios.get(`${API_URL}/admin/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    return response.data;
  } catch (error) {
    console.error('Get admin error:', error);
    return { success: false };
  }
}; 